import React, { useState, useEffect } from 'react';
import ApiManager from '../../ApiManager/ApiManager';
import AddCar from '../../components/CarComponents/AddCar';

const NewCar = () => {
    const [carTypeOptions, setCarTypeOptions] = useState([]);
    const [carFields, setCarFields] = useState([]);


    useEffect(() => {
        const fetchCarTypes = async () => {
            try {
                const params = new URLSearchParams({
                    page_size: 1000,
                    page: 1,
                  });
                const response = await ApiManager.getCarType(params);
                if (!response.ok) throw new Error('Failed to fetch car types');
                const carTypes = await response.json();
                const extractedCarTypes = carTypes.map((car) => car.name);
                setCarTypeOptions(extractedCarTypes);
            } catch (error) {
                console.error('Error fetching car types:', error);
            }
        };

        fetchCarTypes();
    }, []);
    

    useEffect(() => {
        setCarFields([
            ...(carTypeOptions.length > 0
                ? [{ label: 'Car Type', name: 'type', type: 'picklist', required: true, options: carTypeOptions }]
                : [{ label: 'Car Type', name: 'type', type: 'picklist', required: true, options:[]}]),
                { label: 'Vehicle No', name: 'vehicleNo', type: 'text' },
                { label: 'Vehicle Name', name: 'vehicleName', type: 'text' },
                { label: 'Model Name', name: 'modelName', type: 'text' },
                { label: 'Color', name: 'color', type: 'text' },
                { label: 'Fuel Type', name: 'fuelType', type: 'text' },
                { label: 'Assigned Driver ID', name: 'assignedDriverId', type: 'number' },
                { label: 'Capacity', name: 'capacity', type: 'number' },
                { label: 'Permit Type', name: 'permitType', type: 'text', array: 'permits' },
                { label: 'Permit Expiry', name: 'expiry', type: 'date', array: 'permits' },
                { label: 'Owner Name', name: 'ownerName', type: 'text', parent: 'registrationInfo' },
                { label: 'Registration Date', name: 'registrationDate', type: 'date', parent: 'registrationInfo' },
                { label: 'Insurance Company', name: 'insuranceCompany', type: 'text', parent: 'registrationInfo.insuranceInfo' },
                { label: 'Fitness Number', name: 'fitnessNumber', type: 'text', parent: 'registrationInfo.fitnessInfo' },
        ]);
      
    }, [carTypeOptions]);

    return (
        <AddCar
            title="Add Car" 
            formFields={carFields}
            apiFunction={ApiManager.addCar}
        />
    );
};

export default NewCar;
